import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import useEsTelefono from "../../../../utils/esTelefono";
import { EventRowDTO } from "../../../../models/EventDTO";
import { fechaBonita } from "../../../../utils/fechaBonita";
import S from "./strings";
import { EstadoPill, Paginas, dinero, errorText, horaBonita, useOpciones, usePlantel } from "../workshops/comun";
import EventForm from "./eventForm";
import EventDetail from "./eventDetail";

const ESTADOS = ["programado", "realizado", "anulado", "historico", ""];
const TIPOS = ["", "graduacion", "batalla", "seminario", "otro"];

/** Académico › Eventos (sección events, FASE 4): graduaciones, batallas y seminarios. */
const EventsController: React.FC = () => {
	const http = HttpManager.getInstance();
	const movil = useEsTelefono();
	const { campusId, campusName } = usePlantel();
	const opciones = useOpciones(campusId);
	const [estado, setEstado] = useState<string>("programado");
	const [tipo, setTipo] = useState<string>("");
	const [q, setQ] = useState<string>("");
	const [buscar, setBuscar] = useState<string>("");
	const [page, setPage] = useState<number>(1);
	const [data, setData] = useState<{ rows: EventRowDTO[]; total: number; lastPage: number } | null>(null);
	const [abierto, setAbierto] = useState<number | null>(null);
	const [nuevo, setNuevo] = useState<boolean>(false);
	const [aviso, setAviso] = useState<{ text: string; ok: boolean } | null>(null);

	useEffect(() => { const h = setTimeout(() => { setBuscar(q.trim()); setPage(1); }, 350); return () => clearTimeout(h); }, [q]);

	useEffect(() => {
		if (campusId === null || abierto !== null) return;
		let vigente = true;
		setData(null);
		http.eventsService.list(campusId, { status: estado, type: tipo, q: buscar, page, perPage: 50 })
			.then(r => vigente && setData({ rows: r.data.rows || [], total: r.data.total || 0, lastPage: r.data.lastPage || 1 }))
			.catch(e => { if (vigente) { setData({ rows: [], total: 0, lastPage: 1 }); setAviso({ text: errorText(e), ok: false }); } });
		return () => { vigente = false; };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [campusId, estado, tipo, buscar, page, abierto]);

	if (campusId === null) return <React.Fragment />;
	const notify = (text: string, ok = true) => setAviso({ text, ok });

	return (
		<div className={"wau" + (movil ? " movil" : "")}>
			<div className="wau-cab">
				<div>{campusName ? <span className="wau-ceja">{campusName}</span> : ""}<h2>{S.title}</h2></div>
				{abierto === null ? <button type="button" className="wau-btn p" onClick={() => setNuevo(true)}>{S.nuevo}</button> : null}
			</div>
			{aviso ? <div className={"wau-aviso " + (aviso.ok ? "ok" : "mal")} role="status"><span>{aviso.text}</span><button type="button" aria-label={S.cerrar} onClick={() => setAviso(null)}>×</button></div> : ""}
			{abierto !== null ? <EventDetail campusId={campusId} id={abierto} opciones={opciones} onBack={() => setAbierto(null)} notify={notify} /> : (
				<>
					<div className="wau-chips" role="group">
						{ESTADOS.map(c => <button key={c || "todos"} type="button" className="wau-chip" aria-pressed={estado === c} onClick={() => { setEstado(c); setPage(1); }}>{c ? S.estados[c] : S.todos}</button>)}
						<select className="wau-entrada" style={{ width: 170, marginLeft: movil ? 0 : "auto" }} aria-label={S.tipo} value={tipo} onChange={e => { setTipo(e.target.value); setPage(1); }}>
							{TIPOS.map(t => <option key={t || "todos"} value={t}>{t ? S.tipos[t] : S.todos}</option>)}
						</select>
						<input type="search" className="wau-entrada" style={{ width: 240 }} placeholder={S.buscar} value={q} onChange={e => setQ(e.target.value)} />
					</div>
					{data === null ? <div className="wau-caja wau-sec">{S.cargando}</div> : (
						<div className="wau-caja wau-tabla">
							<table>
								<thead><tr><th>{S.col.fecha}</th><th>{S.col.evento}</th><th>{S.col.tipo}</th><th>{S.col.lugar}</th><th className="der">{S.col.asistentes}</th><th className="der">{S.col.paquete}</th><th>{S.col.estado}</th></tr></thead>
								<tbody>
									{data.rows.length === 0 ? <tr><td colSpan={7} className="wau-sec" style={{ textAlign: "center", padding: 20 }}>{S.vacio}</td></tr> : data.rows.map(ev => (
										<tr key={ev.id} className="clic" onClick={() => setAbierto(ev.id)}>
											<td className="wau-num" style={{ whiteSpace: "nowrap" }}>{fechaBonita(ev.date)}<div className="wau-sec" style={{ fontSize: 12.5 }}>{ev.time && ev.time !== "00:00" ? horaBonita(ev.time) : ""}</div></td>
											<td><b>{ev.name}</b></td>
											<td>{ev.typeLabel}</td>
											<td style={{ fontSize: 13.5 }}>{ev.venue || "—"}</td>
											<td className={"der wau-num" + (ev.spotsLeft === 0 ? " wau-oro" : "")}>{ev.counts.total}{ev.capacity ? " / " + ev.capacity : ""}</td>
											<td className="der wau-num">{dinero(ev.currency, ev.packagePrice)}</td>
											<td><EstadoPill status={ev.status} label={ev.statusLabel} /></td>
										</tr>
									))}
								</tbody>
							</table>
							<Paginas page={page} last={data.lastPage} total={data.total} onPage={setPage} />
						</div>
					)}
				</>
			)}
			{nuevo ? <EventForm campusId={campusId} evento={null} onClose={() => setNuevo(false)} onSaved={(e, texto) => { setNuevo(false); notify(texto); setAbierto(e.id); }} /> : null}
		</div>
	);
};

export default EventsController;
